module.exports = __webpack_public_path__ + "static/media/1.54121b3e.JPG";